import { LitElement, html, css } from "lit";

export class HeaderButton extends LitElement {
  static properties = {
    type: { type: String },
  };

  static styles = css`
    :host {
      min-width: fit-content;
    }
    
    .material-icons-outlined,
    .material-symbols-outlined {
      font-family: 'Material Icons Outlined';
      font-weight: normal;
      font-style: normal;
      font-size: 24px;
      line-height: 1;
      letter-spacing: normal;
      text-transform: none;
      display: inline-block;
      white-space: nowrap;
      word-wrap: normal;
      direction: ltr;
      -webkit-font-feature-settings: 'liga';
      -webkit-font-smoothing: antialiased;
    }

    .material-symbols-outlined {
      font-family: 'Material Symbols Outlined';
    }

    button {
      margin-left: 20px;
      font-size: var(--header__button_font-size, 1.125rem);
      font-weight: var(--header__button_fw_mobile, var(--header__button_fw, var(--f-w-3)));
      line-height: 2rem;
      color: var(--header__button__color, #1e1e1e);
      height: 58px;
      width: 125px;
      display: flex;
      align-items: center;
      min-width: fit-content;
      border-radius: var(--header__button__border-radius_mobile, var(--header__button__border-radius, 4px));

      &>div {
        margin: auto;
        display: flex;
      }

      & .header__icon {
        font-size: var(--header__button__icon_font-size_mobile, var(--header__button__icon_font-size, 1.5rem));
      }
    }
    
    .header__button__search {
      background-color: var(--header__searchbutton__bg_mobile, var(--header__button__bg, transparent));
      border:
        var(--header__button__searchborder-width_mobile,
          var(--header__button__searchborder-width,
            var(--header__button__border-width_mobile,
              var(--header__button__border-width, 0px)))) solid var(--header__searchbutton__border-color_mobile,
                                                                  var(--header__button__border-color,
                                                                    var(--primary__color)));
      padding: 3px var(--header__searchbutton__padding-lr, var(--header__button__padding-lr, 10px));
      font-weight: var(--header__searchbutton_fw, var(--header__button_fw, var(--f-w-3)));
      
      & .header__icon:after {
        content: "search";
      }
    }
  `;

  // constructor() {
  //   super();
  // }

  render () {
    return html`
      <button class="header__button__${this.type}" type="button">
        <div>
          <span class="material-icons-outlined notranslate header__icon"></span>
          <span class="header__button__text"><slot></slot></span>
        </div>
      </button>`;
  }
}

customElements.define("header-button", HeaderButton);
